import { useTranslation } from 'react-i18next'
import className from 'classnames'

import './style.scss'

const PostReported = ({ onClick, mayShowInappropriateContent = false }) => {
  const { t } = useTranslation()

  return (
    <a
      className={className('PostReported', {
        'PostReported--disabled': !mayShowInappropriateContent,
      })}
      onClick={onClick}
    >
      {mayShowInappropriateContent
        ? t('post.post_content.report_text')
        : t('post.post_content.report_text_hidden_by_group_setting')}
    </a>
  )
}

export default PostReported
